import { render, staticRenderFns } from "./chart-average-consumption.vue?vue&type=template&id=75145342&scoped=true&"
import script from "./chart-average-consumption.vue?vue&type=script&lang=ts&"
export * from "./chart-average-consumption.vue?vue&type=script&lang=ts&"
import style0 from "./chart-average-consumption.vue?vue&type=style&index=0&id=75145342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75145342",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
